export enum AiAlertAnomalySeverity {
    SEVERITY_UNKNOWN = 'SEVERITY_UNKNOWN',
    SEVERITY_NONE = 'SEVERITY_NONE',
    SEVERITY_LOW= 'SEVERITY_LOW',
    SEVERITY_MEDIUM = 'SEVERITY_MEDIUM',
    SEVERITY_HIGH= 'SEVERITY_HIGH',
    SEVERITY_SEVERE= 'SEVERITY_SEVERE'
}
